import {SoilTranslationsType} from './SoilsTranslationsType';

export const soilsTranslationsEn: SoilTranslationsType = {
  'soils.validation.min': 'Must be above 0',
  'soils.validation.max': 'Must be under 1',
  'soils.validation.rfu_ru': 'This field is required',
  'soils.edit.rfu.error': 'Invalid value',
  'soils.table.rfu_ru': 'RAW/TAW',
  'arvalis.modal.title': 'Set up your RAW/TAW with the help of ARVALIS',
  'arvalis.modal.button.label': 'ARVALIS Simulator',
  'soil.arvalis-modal.button.label': "How to set up my soil if I don't have a complete analysis?",
  'arvalis.modal.text1':
    "You don't know your RAW/TAW precisely? Click on the simulator developed by ARVALIS which will help you define them based on some criteria. This will allow you to improve the reliability of Pixagri's irrigation recommendations throughout the campaign.",
  'arvalis.modal.text2':
    'Then enter the RU value and the RAW/TAW ratio when creating your soil. Also make sure to select the texture closest to your soil.',
};
